import { render } from "./DashboardCard.vue?vue&type=template&id=241f2ef6&scoped=true"
import script from "./DashboardCard.vue?vue&type=script&lang=js"
export * from "./DashboardCard.vue?vue&type=script&lang=js"

import "./DashboardCard.vue?vue&type=style&index=0&id=241f2ef6&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\WebDashBoard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241f2ef6"]])

export default __exports__